import flatten from "flat";

import { axiosWithAuth } from "helpers";

export const mpaUploadService = {
	submitUploadMpa,
	saveUploadMpa,
	saveDraftUploadMpa,
	initializeUploadMpa,
	uploadMpaDocument,
};

const API_URL = process.env.REACT_APP_API_URL;

function submitUploadMpa({ model, mpaId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${mpaId}/submit`,
		data: model,
	};

	return axiosWithAuth(options);
}

function saveUploadMpa({ model, mpaId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${mpaId}/save`,
		data: model,
	};

	return axiosWithAuth(options);
}

function saveDraftUploadMpa({ model, mpaId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${mpaId}/save_draft`,
		data: model,
	};

	return axiosWithAuth(options);
}

function uploadMpaDocument({ document, mpaId }) {
	const formData = new FormData();
	const flatModel = flatten?.(document);

	Object.entries(flatModel).forEach(([key, value]) => {
		if (value == null) {
			return;
		}

		formData.append(key, value);
	});

	return axiosWithAuth({
		method: "POST",
		url: `${API_URL}/api/signed_mpa/${mpaId}/upload_document`,
		data: formData,
		headers: { "Content-Type": undefined },
	});
}

function initializeUploadMpa(body) {
	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/signed_mpa/initialize`,
	};

	return axiosWithAuth(options);
}
